export const liContent = [
  { title: "All Departments" },
  { title: "Arts & Crafts" },
  { title: "Automotive" },
  { title: "Baby" },
  { title: "Beauty & Personal Care" },
  { title: "Books" },
  { title: "Boys' Fashion" },
  { title: "Computers" },
  { title: "Deals" },
  { title: "Digital Music" },
  { title: "Electronics" },
  { title: "Girls' Fashion" },
  { title: "Health & Household" },
  { title: "Home & Kitchen" },
  { title: "Industrial & Scientific" },
  { title: "Kindle Store" },
  { title: "Luggage" },
  { title: "Men's Fashion" },
  { title: "Movies & TV" },
  { title: "Music, CDs & Vinyl" },
  { title: "Pet Supplies" },
  { title: "Prime Video" },
  { title: "Software" },
  { title: "Sports & Outdoors" },
  { title: "Tools & Home Improvement" },
  { title: "Toys & Games" },
  { title: "Video Games" },
  { title: "Women's Fashion" },
];
export const sidebar = [
  {
    title: "Digital Content & Devices",
    one: "Amazon Music",
    two: "Kindle E-readers & Books",
    three: "Amazon Appstore",
  },
  {
    title: "Shop By Department",
    one: "Electronics",
    two: "Computers",
    three: "Smart Home",
  },
  {
    title: "Programs & Features",
    one: "Gift Cards",
    two: "Amazon live",
    three: "International Shopping",
  },
  {
    title: "Help & Settings",
    one: "Your Account",
    two: "Customer Service",
    three: "help",
  },
];
